export const BIRTH_DATE_MIN_YEAR = 1900;

export function getBirthDateMaxYear() {
  return new Date().getFullYear();
}

export function isValidBirthDateParts(year, month, day) {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) return false;
  if (y < BIRTH_DATE_MIN_YEAR || y > getBirthDateMaxYear()) return false;
  if (m < 1 || m > 12 || d < 1 || d > 31) return false;

  const date = new Date(y, m - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date <= today;
}

/** 저장값(YYYY-MM-DD, YYYY-MM-DD(27세) 등)에서 ISO 날짜 추출 */
export function extractBirthDateIso(raw) {
  if (raw == null || raw === '') return '';
  const s = String(raw).trim();
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch && isValidBirthDateParts(isoMatch[1], isoMatch[2], isoMatch[3])) {
    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
  }
  return parseBirthDateDigits(s.replace(/\D/g, ''));
}

/** YYYYMMDD(8자리) → YYYY-MM-DD */
export function parseBirthDateDigits(rawDigits) {
  const digits = String(rawDigits || '').replace(/\D/g, '');
  if (digits.length !== 8) return '';

  const year = digits.slice(0, 4);
  const month = digits.slice(4, 6);
  const day = digits.slice(6, 8);
  if (!isValidBirthDateParts(year, month, day)) return '';
  return `${year}-${month}-${day}`;
}

/** ISO → 화면 표시 (1960-05-05 → 1960.05.05) */
export function formatBirthDateIsoToDisplay(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  if (!y || !m || !d) return '';
  return `${y}.${m}.${d}`;
}

/** 입력 중 숫자 → YYYY.MM.DD 표시 */
export function formatBirthDateDigitsToDisplay(rawDigits) {
  const digits = String(rawDigits || '').replace(/\D/g, '').slice(0, 8);
  if (!digits) return '';
  if (digits.length <= 4) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 4)}.${digits.slice(4)}`;
  return `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6)}`;
}

export function isoToDate(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function dateToIso(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export const BIRTH_DATE_MIN = new Date(BIRTH_DATE_MIN_YEAR, 0, 1);
export const BIRTH_DATE_MAX = new Date();
